/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMessageCheck = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M22 2v8h-2V4H4v16h.501L7.5 16H11v2H8.499L5.5 22H2V2z" />
        <path d="m22.684 13.73-6.017 5.641-3.35-3.142 1.367-1.459 1.982 1.859 4.65-4.359z" />
      </g>
    </g>
  </Icon>
);
export { SvgMessageCheck as MessageCheck };
